import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormInputText from '../../_shared/forms/FormInputText';
import FormInputNumber from '../../_shared/forms/FormInputNumber';
import FormCheckbox from '../../_shared/forms/FormCheckbox';
import FormSelect from '../../_shared/forms/FormSelect';
import DatePicker from 'react-datepicker';
import Dropzone from 'react-dropzone';
import SubmitButton from '../../_shared/SubmitButton';
import FormError from '../../_shared/forms/FormError';

class CustomerCreateJob extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let submitButtonText = this.props.buttonText === 'Edit' ? 'Edit Job' : 'Create Job';
        let { errors, data } = this.props;
        return (
            <form onSubmit={this.props.onSubmit} encType="multipart/form-data" className="transform-text">
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 bg-secondary text-white">Customer Details</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            type="text"
                            label="customer"
                            name="customer_id"
                            value={data.customer_id.name}
                            disabled={true}
                            classes="form-control"
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputText
                            type="text"
                            label="Customer contact"
                            name="customer_contact_id"
                            value={data.customer_contact_id.first_name + ' ' + data.customer_contact_id.last_name}
                            disabled={true}
                            classes="form-control"
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputText
                            myRef={this.props.myRef}
                            label="Purchase Order Number"
                            name="purchase_order_number"
                            type="text"
                            classes={errors.purchase_order_number ? 'form-control is-invalid' : 'form-control'}
                            value={data.purchase_order_number}
                            handleChange={this.props.handleChange}
                            error={errors.purchase_order_number}
                        />
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 bg-secondary text-white">Address Details</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="Address Line 1"
                            name="address_line_1"
                            type="text"
                            classes={errors.address_line_1 ? 'form-control is-invalid' : 'form-control'}
                            value={data.address_line_1}
                            handleChange={this.props.handleChange}
                            error={errors.address_line_1}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Address Line 2"
                            name="address_line_2"
                            type="text"
                            classes={errors.address_line_2 ? 'form-control is-invalid' : 'form-control'}
                            value={data.address_line_2}
                            handleChange={this.props.handleChange}
                            error={errors.address_line_2}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Postcode"
                            name="postcode"
                            type="text"
                            classes={errors.postcode ? 'form-control is-invalid' : 'form-control'}
                            value={data.postcode}
                            handleChange={this.props.handleChange}
                            error={errors.postcode}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="City"
                            name="city"
                            type="text"
                            classes={errors.city ? 'form-control is-invalid' : 'form-control'}
                            value={data.city}
                            handleChange={this.props.handleChange}
                            error={errors.city}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Telephone"
                            name="telephone"
                            type="text"
                            classes={errors.telephone ? 'form-control is-invalid' : 'form-control'}
                            value={data.telephone}
                            handleChange={this.props.handleChange}
                            error={errors.telephone}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="On-Site Contact Name"
                            name="os_contact_name"
                            type="text"
                            classes={errors.os_contact_name ? 'form-control is-invalid' : 'form-control'}
                            value={data.os_contact_name}
                            handleChange={this.props.handleChange}
                            error={errors.os_contact_name}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="On-Site Contact Mobile"
                            name="os_contact_mobile"
                            type="text"
                            classes={errors.os_contact_mobile ? 'form-control is-invalid' : 'form-control'}
                            value={data.os_contact_mobile}
                            handleChange={this.props.handleChange}
                            error={errors.os_contact_mobile}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <FormCheckbox
                            name="os_contact_updates"
                            label="ON-SITE CONTACT JOB UPDATES"
                            checked={data.os_contact_updates}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 bg-secondary text-white">Details</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <label htmlFor="description">Special Requests</label>
                        <textarea
                            className="form-control"
                            name="special_requests"
                            id="special_requests"
                            value={data.special_requests}
                            onChange={this.props.handleChange}
                            placeholder="Please add any details that will assist our co-ordinators in their planning e.g call tenant before attending or needle sweep required"
                            rows="5"
                        ></textarea>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <label htmlFor="description">Description</label>
                        <textarea
                            className="form-control"
                            name="description"
                            id="description"
                            value={data.description}
                            onChange={this.props.handleChange}
                            placeholder="Description..."
                            rows="5"
                        ></textarea>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-4">
                        <FormSelect
                            classes={errors.job_type_id ? 'form-control is-invalid' : 'form-control'}
                            name="job_type_id"
                            options={this.props.jobs}
                            value={data.job_type_id}
                            handleChange={this.props.handleChange}
                            label="job type"
                            error={errors.job_type_id}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputNumber
                            type="number"
                            label="Quantity"
                            name="quantity"
                            step="1"
                            min="1"
                            classes={errors.quantity ? 'form-control is-invalid' : 'form-control'}
                            value={data.quantity}
                            handleChange={this.props.handleChange}
                            error={errors.quantity}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Date ready</label>
                        {(() => {
                            const now = new Date();
                            const currentHour = now.getHours();
                            const afterTwoPM = currentHour >= 14;

                            const today = new Date();
                            const tomorrow = new Date();
                            tomorrow.setDate(today.getDate() + 1);

                            return (
                                <>
                                    <DatePicker
                                        className={errors.date_ready ? 'is-invalid form-control' : 'form-control'}
                                        placeholderText="Date ready..."
                                        minDate={today}
                                        onChange={(date) => this.props.handleDateChange(date, 'date_ready')}
                                        selected={data.date_ready || null}
                                        dateFormat="dd/MM/yyyy"
                                        filterDate={(date) => {
                                            if (!this.props.isWeekday(date)) return false;
                                            const todayNoTime = new Date();
                                            todayNoTime.setHours(0, 0, 0, 0);
                                            const dateNoTime = new Date(date);
                                            dateNoTime.setHours(0, 0, 0, 0);
                                            if (afterTwoPM && dateNoTime.getTime() === todayNoTime.getTime()) {
                                                return false;
                                            }

                                            return true;
                                        }}
                                        isClearable
                                    />

                                    {errors.date_ready ? <FormError error={errors.date_ready} /> : ''}

                                    <small className="form-text text-muted">
                                        {afterTwoPM
                                            ? 'After 2 PM, today is no longer available — please choose a later date.'
                                            : 'You can select today until 2 PM.'}
                                    </small>
                                </>
                            );
                        })()}
                    </div>
                </div>

                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 bg-secondary text-white">Photos/Videos</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Dropzone
                            onDrop={(acceptedFiles) => this.props.onDrop(acceptedFiles)}
                            onDropRejected={(rejectedFiles) => this.props.onDropReject(rejectedFiles, this.props.name)}
                            maxSize={55000000}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <section>
                                    <div
                                        {...getRootProps()}
                                        className="d-flex flex-column align-items-center jobs-dropzone"
                                    >
                                        <input {...getInputProps()} />
                                        {data.acceptedFiles.length > 0 ? (
                                            <div className="row w-100">
                                                {data.acceptedFiles.map((file, index) => (
                                                    <div
                                                        key={index}
                                                        className="col-md-2 d-flex flex-column justify-content-between"
                                                    >
                                                        {file.type.match('video.*') ? (
                                                            <video
                                                                id="video-element"
                                                                style={{
                                                                    height: '100px',
                                                                }}
                                                                controls
                                                            >
                                                                <source
                                                                    style={{
                                                                        height: '100px',
                                                                    }}
                                                                    src={window.URL.createObjectURL(file)}
                                                                    type={file.type}
                                                                />
                                                            </video>
                                                        ) : (
                                                            <img
                                                                src={window.URL.createObjectURL(file)}
                                                                className="img-fluid"
                                                            />
                                                        )}
                                                        <div
                                                            className="text-center dropzone-remove-link"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                this.props.removeFile(file, index);
                                                            }}
                                                        >
                                                            remove <i className="fas fa-times"> </i>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="py-5 text-muted mb-0 jobs-dropzone-placeholder">
                                                Drag and drop, or click to select images and videos related to this job
                                            </p>
                                        )}
                                    </div>
                                    <div></div>
                                </section>
                            )}
                        </Dropzone>
                        {this.props.rejectedFiles && this.props.rejectedFiles[this.props.name] ? (
                            <p className="text-danger mt-2">Photo size must be less than 5mb</p>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            label="Job Created By"
                            name="created_by"
                            type="text"
                            classes={errors.created_by ? 'form-control is-invalid' : 'form-control'}
                            value={this.props.createdBy ?? ''}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>
                <SubmitButton
                    buttonText={submitButtonText}
                    loading={data.loading}
                    style={{ width: 200, marginTop: 50 }}
                />
            </form>
        );
    }
}

export default CustomerCreateJob;
